<template>
    <el-dialog
            :title="'详情'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form  ref="dataForm"
                  label-width="150px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="谈话人工号" prop="thrgh">
                        <div class="min-input-class">{{dataForm.thrgh}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="被谈话人工号" prop="bthrgh">
                        <div class="min-input-class">{{dataForm.bthrgh}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="谈话人姓名" prop="thrxm">
                        <div class="min-input-class">{{dataForm.thrxm}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="被谈话人姓名" prop="bthrxm">
                        <div class="min-input-class">{{dataForm.bthrxm}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="谈话人部门" prop="thrbmmc">
                        <div class="min-input-class">{{dataForm.thrbmmc}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="被谈话人部门" prop="bthrbmmc">
                        <div class="min-input-class">{{dataForm.bthrbmmc}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="谈话原因" prop="thyy">
                        <div class="min-input-class">{{dataForm.thyy}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="谈话时间" prop="thsj">
                        <div class="min-input-class">{{dataForm.thsj}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
               <el-col :span="12">
                    <el-form-item label="谈话状态" prop="thzt">
                       <div class="min-input-class">
                            <el-tag v-if="dataForm.thzt === '01'" type="success">正常</el-tag>
                            <el-tag v-if="dataForm.thzt === '02'" type="error">异常</el-tag>
                       </div>
                   </el-form-item>
               </el-col>
<!--                <el-col :span="12">-->
<!--                    <el-form-item label="异常类型" prop="talkException">-->
<!--                        <div class="min-input-class">-->
<!--                            <el-tag v-if="dataForm.talkStatus && dataForm.talkStatus !==0"  type="success">{{dataForm.exceptionName}}</el-tag>-->
<!--                        </div>-->
<!--                    </el-form-item>-->
<!--                </el-col>-->
           </el-row>
            <el-row>
                <el-form-item label="谈话情况描述" prop="thqkms">
                    <div class="min-input-class">{{dataForm.thqkms}}</div>
                </el-form-item>
            </el-row>
<!--            <el-row>-->
<!--                <el-col :span="12">-->
<!--                    <el-form-item label="处理人" prop="handleTime">-->
<!--                        <div class="min-input-class">{{dataForm.clrxm}}</div>-->
<!--                    </el-form-item>-->
<!--                </el-col>-->
<!--                <el-col :span="12">-->
<!--                    <el-form-item label="处理时间" prop="handleTime">-->
<!--                        <div class="min-input-class">{{dataForm.handleTime}}</div>-->
<!--                    </el-form-item>-->
<!--                </el-col>-->
<!--            </el-row>-->
<!--            <el-row>-->
<!--                <el-col :span="12">-->
<!--                    <el-form-item label="处理结果" prop="handleContent">-->
<!--                        <div class="min-input-class">{{dataForm.handleContent}}</div>-->
<!--                    </el-form-item>-->
<!--                </el-col>-->
<!--            </el-row>-->

        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        components: {},
        data () {
            return {
                visible: false,
                dataForm: {},
            }
        },
        methods: {
            init (obj) {
                if(!obj) return;
                this.visible = true
                this.$nextTick(() => {
                    this.dataForm = obj
                })

            }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
